import MenubarLanding from "../MenubarLanding"
import { Divider } from 'primereact/divider';
import React, { useState, useEffect } from "react";
import "./index.scss"
import DSC_0010 from "../../assets/img/programs/program-health.jpg"
import DSC_0079 from "../../assets/img/programs/program-bread-love.jpg"
import IMG_0106 from "../../assets/img/programs/program-learning.jpg"
import DSC_0103 from "../../assets/img/programs/program-gallery-1.jpg"
import IMG_0052 from "../../assets/img/programs/program-gallery-2.jpg"
import IMG_0101 from "../../assets/img/programs/program-gallery-3.jpg"
import DSC_0013 from "../../assets/img/programs/program-gallery-4.jpg"
import DSC_0018 from "../../assets/img/programs/program-gallery-5.jpg"
import _DSC0130 from "../../assets/img/programs/program-gallery-6.jpg"
import { Dialog  } from 'primereact/dialog';
import { Button } from 'primereact/button'; 

export default function Program() {
    const [visible, setVisible] = useState(false);
    const images = [DSC_0010, DSC_0079, IMG_0106, DSC_0103, IMG_0101, DSC_0013,IMG_0052,DSC_0018,_DSC0130]

      const [language, setLanguage] = useState(localStorage.getItem("lang") || "es");
    
      useEffect(() => {
            const handleLanguageChange = () => {
                setLanguage(localStorage.getItem("lang") || "es");
            };
    
            window.addEventListener("languageChange", handleLanguageChange);
    
            return () => window.removeEventListener("languageChange", handleLanguageChange);
        }, []);

        const valuesColors = [
            "#8c458a", "#D9991E", "#9DAD2A", "#8c458a", "#D9991E", "#c3b8d8", "#8c458a",  
            "#8c458a", "#D9991E", "#9DAD2A", "#8c458a", "#D9991E", "#c3b8d8", "#8c458a",  
            "#D9991E", "#9DAD2A", "#8c458a", "#D9991E", "#c3b8d8", "#8c458a", "#D9991E", "#8c458a", "#c3b8d8"
            ];    
        
        const colorizeText = (text) => {
            return text.split('').map((char, index) => (
                <span key={index} style={{ color: valuesColors[index % valuesColors.length] }}>{char}</span>
            ));
        };

    return (
        <div>
            <MenubarLanding />
            <div className="program-container-primary">
                <div className="program-container-secondary">
                    <div className="grid2-content">
                        
                        <div className="program-title span-2">
                            <h2>{colorizeText(language === "es" ? "Programas" : "Programs")}</h2>
                        </div>

                        <div>
                            <h1>{colorizeText(language === "en" ? "Learning without barriers" : "Aprendiendo sin barreras")}</h1>
                            <p>{language === "en" ? "Promotion of activities consisting of craft workshops, motivational talks and various training sessions, which seek to develop their creative and productive capacities, oriented towards a projection of social and/or productive entrepreneurship and the social inclusion of the participants." : "Promoción de actividades compuestas por talleres artesanales, charlas motivacionales y diversas capacitaciones, que buscan el desarrollo de sus capacidades creativas y productivas, orientadas a una proyección de emprendimiento social y/o productivo y la inclusión social de los participantes."}</p>
                        </div>

                        <div>
                            <img src={IMG_0106}></img>
                        </div>

                        <Divider className="span-2" />

                        <div>
                            <img src={DSC_0010}></img>
                        </div>

                        <div>
                            <h1>{colorizeText(language === "en" ? "Health & Wellness" : "Salud & Bienestar")}</h1>
                            <p>  {language === "en" ? "Waima seeks to provide recreational spaces, integration activities, promotion and prevention in physical and mental health to improve the quality of life of beneficiaries." : "Waima busca propiciar espacios recreativos, actividades de integración, promoción y prevención en salud física y mental para el mejoramiento de la calidad de vida de los beneficiarios. "}
                            </p>
                        </div>

                        <Divider className="span-2" />

                        <div>
                            <h1>{colorizeText(language === "en" ? "Bread and Love" : "Pan y Amor")}</h1>
                            <p> {language === "en" ? "We aim to contribute to the nutrition of our beneficiaries by providing food packages and lunch to children who attend extracurricular classes." : "Se busca aportar a la nutrición de nuestros beneficiarios con la entrega de paquetes alimentarios y entrega de almuerzo a los niños que asisten a las clases extracurriculares. "}
                            </p>
                        </div>

                        <div>
                            <img src={DSC_0079}></img>
                        </div>

                        <div className="span-2 programBTN-container">
                            <Button label={language ==="es" ? "Ver Galería" : "See Gallery"} icon="pi pi-external-link" onClick={() => setVisible(true)} className="program-button" />
                            <Dialog header="Learn about us" visible={visible} style={{ width: '80vw' }} onHide={() => {if (!visible) return; setVisible(false); }}>
                                <div className="dialog-box-container">
                                    {images.map((image, index) => {
                                        return (
                                            <div key={index}>
                                                <img src={image} alt="image" />
                                            </div>
                                        )
                                    })}
                                </div>
                            </Dialog>
                        </div>

                    </div>
                </div>
            </div>

            <div className="program-container-primary">
                <div className="program-container-secondary">
                    <div className="grid2-content">

                        <div className="program-title span-2">
                            <h2>{colorizeText(language === "es" ? "Nuestras Campañas" : "Our Campaigns")}</h2>
                        </div>

                        <div>
                            <h1>{colorizeText(language === "en" ? "Utilatón" : "Utilatón")}</h1>
                            <p>
                            {language === "en" ? "This initiative aims to benefit low-income children affiliated with the Waima Foundation and students at rural schools in the municipality of Campamento by collecting and distributing school supplies that will help them stay in school and improve their learning conditions." : "Busca beneficiar a niños y niñas de escasos recursos pertenecientes a la Fundación Waima y a estudiantes de instituciones educativas rurales del municipio de Campamento, mediante la recolección y entrega de útiles escolares que contribuyan a su permanencia educativa y mejoren sus condiciones para el aprendizaje."}
                            </p>
                        </div>

                        <div>
                            <h1>
                                {colorizeText(language === "en" ? "Sponsorship Plan" : "Plan Padrino")}
                            </h1>
                            <p>
                            {language === "en" ? "This program promotes the sponsorship of children at the Waima Foundation through a monthly contribution of 50,000 pesos, which is used to improve their nutrition and ensure their participation in the programs, educational activities, and holistic development opportunities offered by the Foundation." : "Promueve el apadrinamiento de niños y niñas de la Fundación Waima a través de un aporte mensual de $50.000, destinado a fortalecer su alimentación y garantizar su participación en los programas, actividades formativas y espacios de desarrollo integral que ofrece la Fundación."}
                            </p>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}